import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _AcademicEducation, _Certifications } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { SelectTHConstantsValue } from "../../../../bpm/config/Componentes/SelectTHConstantsValue";
import { InputDate } from "../../../../theme/Input/InputDate";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { DepartamentCitiesEditor } from "../../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/Components/DepartamentCitiesEditor";
import { SelectSiteID } from "../../../../admin/configuracion/SiteID/SelectSiteID";
import { CountryEditor } from "../../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/Components/CountryEditor";
import usePaginator from "../../../../theme/Component/usePaginator";


interface Props {
    Account: number;
}

export const Certifications = ({ Account }: Props) => {

    const Certifications = useDataBean(_Certifications);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();
    useEffect(() => {
        getListavdos();
    }, [Account])

    const getLista = () => {

        Certifications.instance.getCertificationsCatalogPorPropiedades({ State: 1, IDAccount: Account }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )

    }

    const getListavdos = () => {

        Certifications.instance.getCertificationsAccountReport(paginador.page, 15, { State: 1, IDAccount: Account }).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        Certifications.setBean({
            IDAccount: Account,
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        Certifications.update().then(
            (resp: any) => {
                getListavdos();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        Certifications.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }
    const head = [
        { title: 'ID', property: 'IDAcademicEducationAccount', visible: true },
        { title: 'Nombre del curso', property: 'CourseName', visible: true },
        { title: 'Entidad que Otorgo', property: 'IssuingEntityName', visible: true },
        { title: 'Duracion Horas', property: 'DurationHours', visible: true },
        { title: 'Modalidad', property: 'IDModalityName', visible: true },
        { title: 'Fecha Inicial', property: 'StartDate', visible: true },


        { title: 'Fecha Final', property: 'EndDate', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={Certifications.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Nombre del curso</label>
                            <input type='text' name="CourseName" className="form-control" value={Certifications.bean.CourseName} onChange={Certifications.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Entidad que Otorgo</label>
                            <SelectTHConstantsValue code={103} value={Certifications.bean.IssuingEntity} onChange={(e: any) => { Certifications.setBean({ ...Certifications.bean, "IssuingEntity": e }) }}></SelectTHConstantsValue>
                        </div>
                        <div className="col-md-6">
                            <label>Duracion Horas</label>
                            <input type='text' name="DurationHours" className="form-control" value={Certifications.bean.DurationHours} onChange={Certifications.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <InputDate name="StartDate" label="Fecha Inicial" value={Certifications.bean.StartDate} setDate={(e: any) => { Certifications.setBean({ ...Certifications.bean, "StartDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <InputDate name="EndDate" label="Fecha Final" value={Certifications.bean.EndDate} setDate={(e: any) => { Certifications.setBean({ ...Certifications.bean, "EndDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Modalidad</label>
                            <SelectTHConstantsValue code={806} value={Certifications.bean.IDModality} onChange={(e: any) => { Certifications.setBean({ ...Certifications.bean, "IDModality": e }) }}></SelectTHConstantsValue>
                        </div>

                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}